<template>
    <v-container>
      <h3>PLACEHOLDER VIEW : {{ this.$route.path }}</h3>
    </v-container>
</template>

<script>

export default {
}
</script>
